<template>
  <VTDropDownPill
    :is-enabled="isEditable"
    :class="$style.wrapper"
    :disable-save-button="!isValidImageName"
    @on-click-outside="reset()"
    @clear="reset()"
    @confirm="handleUpdate()"
  >
    <template #dropDownHeader>
      <InputGroup :class="$style.inputGroup">
        <InputGroupAddon>
          <VdIcon store="fas" name="image" size="large"></VdIcon>
        </InputGroupAddon>
        <InputText id="image" v-model="imageValue" :disabled="true" :class="$style.inputText" />
        <InputGroupAddon :class="isEditable ? $style.editButton : ''">
          <VdIcon store="fa" name="pen-to-square" size="large"></VdIcon>
        </InputGroupAddon>
      </InputGroup>
    </template>
    <template #dropdown-content>
      <div :class="$style.container">
        <InputText
          v-model.trim="imageValue"
          :disabled="!isEditable"
          placeholder="Edit image name"
          @keydown="handleKeyDown"
        />
      </div>
    </template>
  </VTDropDownPill>
</template>
<script setup lang="ts">
import VdIcon from "@/components/VdIcon/VdIcon.vue";
import VTDropDownPill from "@/components/VTDropdownPill";
import isTrimmedAndNonEmpty from "@/utils/isTrimmedAndNonEmpty";
import { prohibitInput } from "@/utils/prohibitInput";
import InputGroup from "primevue/inputgroup";
import InputGroupAddon from "primevue/inputgroupaddon";
import InputText from "primevue/inputtext";
import { computed, ref, watch } from "vue";

const props = defineProps({
  image: {
    type: String,
    default: "",
  },
  isEditable: {
    type: Boolean,
    default: true,
  },
});

const imageValue = ref(props.image);

watch(
  () => props,
  () => {
    reset();
  },
  { deep: true }
);

const emits = defineEmits(["update"]);

function reset() {
  imageValue.value = props.image;
}
function handleUpdate() {
  emits("update", imageValue.value);
}

const isValidImageName = computed(() => imageValue.value && isTrimmedAndNonEmpty(imageValue.value));

function handleKeyDown(event: KeyboardEvent) {
  prohibitInput(event, [" "]);
}
</script>

<style module>
.container {
  padding: 4px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 1rem;
}

.wrapper {
  width: 100%;
}

.editButton {
  cursor: pointer;
}

.inputGroup {
  height: 32px;
}

.inputText {
  border-right: none;
  border-left: none;
  border-top: 1px solid #bcbec1;
  border-bottom: 1px solid #bcbec1;
  opacity: 1;
  font-size: 12px;
  color: var(--vd-color-text-dark);
  padding-left: 0;
}
</style>
